export default function throttleAsync<T extends (
    ...args: any[]
) => Promise<any>>(
    func: T,
    delay: number,
): (...args: Parameters<T>) => Promise<void> {
    let isThrottled = false;
    let lastArgs: Parameters<T> | null = null;

    return async function throttled(
        ...args: Parameters<T>
    ): Promise<void> {
        if (isThrottled) {
            lastArgs = args;
            return;
        }

        isThrottled = true;

        // ts too stupid
        // @ts-ignore
        await func.apply(this, args);

        setTimeout(async () => {
            isThrottled = false;

            if (lastArgs) {
                const argsToUse = lastArgs;
                lastArgs = null;

                isThrottled = true;

                // ts too stupid
                // @ts-ignore
                await func.apply(this, argsToUse);

                setTimeout(() => {
                    isThrottled = false;
                }, delay);
            }
        }, delay);
    };
}
